import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { IAlert } from '../../models/alert.model';
import { AlertService } from '../../service/alert.service';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'app-alert',
    imports: [DialogComponent],
    templateUrl: './alert.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AlertComponent implements OnInit, OnDestroy {
  alerts: IAlert[] = [];

  private subscription?: Subscription;
  private timers = new Map<number, ReturnType<typeof setTimeout>>();

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.alertEvent.subscribe(alert => this.addAlert(alert));
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.timers.forEach(timer => clearTimeout(timer));
  }

  private addAlert(alert: IAlert): void {
    this.alerts.push(alert);

    if (alert.data.useTimeout) {
      const timerId = setTimeout(() => this.dismiss(alert.id), 5000);
      this.timers.set(alert.id, timerId);
    }
  }

  dismiss(id: number): void {
    this.alerts = this.alerts.filter(a => a.id !== id);
    const timer = this.timers.get(id);
    if (timer) {
      clearTimeout(timer);
      this.timers.delete(id);
    }
  }
}